import { defaultStore, stores } from '../../../../../translations';
import { useInteractiveShop } from '../../../../../redux/reducer/content';
import content from '../../constants/content';
// import useTreeSequence from '../../model/hooks/useTreeSequence';
// import { image } from '../../../../../utils/data/baseUrl';

const {
  // treeSequence,
  images: { table, background: backgroundProps, tableLight },
} = content;

export default function Images() {
  const { background } = useInteractiveShop();
  // const setImage = useTreeSequence();

  return (
    <div className={'interactive-shop__area-images'}>
      <img src={background} {...backgroundProps} />
      {/*{defaultStore !== stores.ae &&*/}
      {/*  Array.from({ length: treeSequence.length }).map((_, i) => (*/}
      {/*    <img*/}
      {/*      key={i}*/}
      {/*      ref={(ref) => setImage(ref, i)}*/}
      {/*      {...treeSequence.imgProps}*/}
      {/*      src={image(`interactiveShop/other/tree-sequence-${i + 1}.png`)}*/}
      {/*    />*/}
      {/*  ))}*/}
      {defaultStore === stores.ru && (
        <>
          <img {...tableLight} />
          <img {...table} />
        </>
      )}
    </div>
  );
}
